<script setup lang="ts">
import { init as initOffice, isActive as isOfficeActive } from "./store/Office";
import DarkButton from "./components/DarkButton.vue";
import BackToTop from "./components/BackToTop.vue";
import Toast from "./components/Toast.vue";
import { toastVisible, toastMessage, toastType } from "./store/Toast";
import { useRoute, useRouter } from "vue-router";

initOffice();

const router = useRouter();
const route = useRoute();

const home = () => {
  router.push({ name: "home" });
};

const anonymiser = async () => {
  await Word.run(async (context) => {
    context.document.properties.customProperties.deleteAll();
    return await context.sync();
  });
};
</script>

<template>
  <header class="
      sticky
      top-0
      z-50
      border-b
      border-gray-200
      dark:border-gray-700
      bg-white
      dark:bg-gray-900
      h-16
      shadow-sm
    ">
    <div class="
        px-4
        lg:px-6
        py-4
        flex
        items-center
        justify-between
        container
        mx-auto
      ">
      <!-- Logo simple -->
      <div class="flex items-center gap-2">
        <div class="
            flex
            items-center
            gap-2
            text-gray-900
            dark:text-gray-100
            cursor-pointer
            text-lg
            font-semibold
            hover:text-primary-600
            dark:hover:text-primary-400
            transition-colors
            duration-150
          " @click="home">
          <!-- Icône de retour -->
          <fa v-if="route.name === 'category' && !isOfficeActive"
              :icon="['far', 'arrow-left']"
              class="text-primary-600 dark:text-primary-400"
          />

          <!-- Logo -->
          <span class="text-primary-600 dark:text-primary-400">téoedit</span>
          <span class="text-gray-600 dark:text-gray-400 font-normal">Assistant</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-2">
        <!-- Bouton Aide -->
        <a href="https://aide.teoapp.fr/docs/teoedit/creer-vos-modeles-de-courriers/"
           class="
             flex items-center gap-2
             px-3 py-1.5
             bg-primary-600
             hover:bg-primary-700
             text-white
             text-sm
             font-medium
             rounded-lg
             transition-colors
             duration-150
           "
           target="_blank"
           rel="noopener noreferrer">
          <fa :icon="['far', 'question-circle']" />
          <span class="hidden sm:inline">Aide</span>
        </a>

        <!-- Bouton Dark Mode -->
        <DarkButton />
      </div>
    </div>
  </header>
  <main class="flex-1 text-gray-900 dark:text-gray-100 px-4 lg:px-6 py-6 container mx-auto">
    <RouterView />
    <BackToTop />

    <!-- Toast global -->
    <Toast
      :show="toastVisible"
      :message="toastMessage"
      :type="toastType"
      @close="toastVisible = false"
    />

    <!-- Section Outils Word -->
    <div v-if="isOfficeActive" class="mt-12 text-center">
      <div class="w-full h-px bg-gray-300 dark:bg-gray-700 my-8"></div>

      <h2 class="mb-4 text-gray-900 dark:text-gray-100 font-semibold">
        Outils Word
      </h2>

      <button class="
          px-6
          py-3
          bg-white
          dark:bg-gray-800
          border
          border-gray-300
          dark:border-gray-700
          rounded-lg
          hover:border-primary-500
          dark:hover:border-primary-500
          hover:bg-gray-50
          dark:hover:bg-gray-700
          text-gray-900
          dark:text-gray-100
          font-medium
          transition-colors
          duration-150
        " @click="anonymiser()">
        Suppression des propriétés personnalisées
      </button>
    </div>
  </main>

  <!-- Footer simple -->
  <footer class="
      bg-gray-50
      dark:bg-gray-800
      border-t
      border-gray-200
      dark:border-gray-700
    ">
    <div class="flex items-center justify-center p-4 mx-auto container">
      <p class="text-sm text-center text-gray-600 dark:text-gray-400">
        <span class="text-primary-600 dark:text-primary-400 font-semibold">téo</span>
        {{ new Date().getFullYear() }}, tous droits réservés.
      </p>
    </div>
  </footer>
</template>
